import { AfterViewInit, Component, EventEmitter, Input, Output } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ToastrService } from 'ngx-toastr';
import { ActivatedRoute, Router } from '@angular/router';
import { LicensePricingForm } from './license-pricing.form';
import { AbstractFormComponent } from '../../../../../shared/crud/component/form.component';
import { IConfirmationDialogPayload } from '../../../../../shared/ui/component/confirmation-dialog/confirmation-dialog-payload.interface';
import { ErrorCodes } from '../../../../../shared/enum/api-errors';

@Component({
  selector: 'admin-license-pricing-form',
  templateUrl: './form.component.html',
  styleUrls: [ './form.component.scss' ]
})
export class AdminLicensePricingFormComponent extends AbstractFormComponent implements AfterViewInit {

  @Input() license: any;
  @Input() row: any;
  @Input() selectedRowId: number;
  @Output() deleteSubject = new EventEmitter();
  isEditMode: boolean = false;

  constructor(formBuilder: LicensePricingForm,
              httpClient: HttpClient,
              toastrService: ToastrService,
              router: Router,
              route: ActivatedRoute) {
    super(formBuilder, httpClient, toastrService, router, route);
  }

  ngOnInit() {
    super.ngOnInit();
    this.record = this.row;
    this.form.patchValue(this.row);
  }

  ngAfterViewInit() {
    if (this.row.id) {
      this.formMode = 'update';
      this.form.reset(this.row);
    } else {
      this.formMode = 'create';
    }
  }

  protected getUrl(forceId?: number): string {
    const params = this.route.snapshot.params;
    return '/admin/license-pricing' + (params.id ? `/${params.id}` : forceId ? `/${forceId}` : '');
  }


  submit(): void {
    this.form.value.license = this.license.id;
    this.form.value.limit = Number(this.form.value.limit);
    this.form.value.unitPrice = Number(this.form.value.unitPrice);
    this.form.value.blockPrice = Number(this.form.value.blockPrice);
    this.form.value.isFree = Boolean(this.form.value.isFree);

    super.submit();
  }

  protected onSubmit(response: any): void {
    this.toastrService.success('Saved');
  }

  load(id: number) {
    this.loading = true;
    let url = this.getUrl(id);
    if (this.urlBuilder) {
      url = this.urlBuilder.buildUrl(url);
    }
    this.httpClient.get<any>(url)
      .subscribe(
        (data: any) => {
          this.row = data;
          this.form.patchValue(this.row);
          this.loading = false;
        },
        (error: any) => {
          this.toastrService.error(error.error ? (error.error.message || ErrorCodes[error.error.code] || 'Something went wrong...') : 'Error');
          this.loading = false;
        }
      );
  }

  delete(): any {
    if (!this.row.id) {
      this.row = null;
      this.deleteSubject.next(<IConfirmationDialogPayload>{
        result: true,
        message: 'Deleted'
      });
      return;
    }
    return this.httpClient.delete<any>(this.getUrl(this.row.id))
      .subscribe((response: any) => {
        this.deleteSubject.next(<IConfirmationDialogPayload>{
          result: true,
          message: 'Deleted'
        });

        this.row = null;
        return response;
      }, (error: any) => {
        this.deleteSubject.next(<IConfirmationDialogPayload>{
          result: false,
          message: 'Unable to delete'
        });

        return error;
      });
  }

}
